import { appStateMachine } from '@/lib/machines/app-state-machine';
import { useMachine } from '@xstate/react';
import type { ReactNode } from 'react';
import React, { createContext, useContext, useMemo } from 'react';
import type { ActorRefFrom, SnapshotFrom } from 'xstate';

type AppStateMachineType = ReturnType<typeof appStateMachine>;

type MyMachineContextProps = {
    state: SnapshotFrom<AppStateMachineType>;
    send: ActorRefFrom<AppStateMachineType>['send'];
};

// Your context creation remains the same
const MyMachineContext = createContext<MyMachineContextProps | null>(null);

// Your provider props
type AppStateMachineProviderProps = {
    children: ReactNode;
};

export const AppStateMachineProvider: React.FC<AppStateMachineProviderProps> = ({ children }) => {
    const machine = useMemo(() => appStateMachine(), []);
    const [state, send] = useMachine(machine);
    return <MyMachineContext.Provider value={{ state, send }}>{children}</MyMachineContext.Provider>;
};

// Your custom hook
export const useAppStateMachine = (): MyMachineContextProps => {
    const context = useContext(MyMachineContext);
    if (!context) {
        throw new Error('useAppStateMachine must be used within a AppStateMachineProvider');
    }
    return context;
};
